// extracted by mini-css-extract-plugin
export default {"root":"UserNav_root__iVs5Y","tab":"UserNav_tab__GhBRF","tabLabel":"UserNav_tabLabel__cXevD","tabIcon":"UserNav_tabIcon__wmxJo"};